export type TextChipVariant = 'gentle' | 'balanced' | 'advanced' | 'default';

/** The variants that carry a friendly label; anything else falls back to `default`. */
type LabelledVariant = Exclude<TextChipVariant, 'default'>;

export interface TextChipsProps {
  readonly value: string;
  readonly className?: string;
}

const VARIANT_LABEL: Record<LabelledVariant, string> = {
  gentle: 'Friendly',
  balanced: 'Balanced',
  advanced: 'Challenging',
};

const VARIANT_CLASS: Record<TextChipVariant, string> = {
  gentle: 'bg-mint/20 text-mint',
  balanced: 'bg-sky/20 text-sky',
  advanced: 'bg-berry/20 text-berry',
  default: 'bg-sun/20 text-ink',
};

export function TextChips({ value, className = '' }: TextChipsProps) {
  const isLabelled = value in VARIANT_LABEL;
  const variant: TextChipVariant = isLabelled ? (value as LabelledVariant) : 'default';
  const display = isLabelled ? VARIANT_LABEL[value as LabelledVariant] : value;
  return (
    <span
      data-testid={`text-chip-${value}`}
      aria-label={`${value} — ${display}`}
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-bold ${VARIANT_CLASS[variant]} ${className}`}
    >
      {display}
    </span>
  );
}
